import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/material";
import React from "react";
import { useCancelTransferRequest, useCreateTransferRequest, useListUserTransferRequests, } from "../api/TransferRequestApiProvider";
import ErrorSnackbar from "../utils/ErrorSnackbar";
export const TransferRequestButton = ({ team }) => {
    const { data: userTransferRequests, error: userTransferRequestsError, isLoading: userTransferRequestsIsLoading, isRefetching, } = useListUserTransferRequests();
    const teamTransferRequest = userTransferRequests?.find((transferRequest) => transferRequest.team === team.id);
    const submitTransferRequestMutation = useCreateTransferRequest({
        team,
        onMutate: () => { },
        onSuccess: () => { },
        onError: () => { },
    });
    const deleteTransferRequestMutation = useCancelTransferRequest({
        transferRequest: teamTransferRequest,
        onMutate: () => { },
        onSuccess: () => { },
        onError: () => { },
    });
    const handleSubmit = () => {
        submitTransferRequestMutation.mutate();
    };
    const handleCancel = () => {
        if (teamTransferRequest) {
            deleteTransferRequestMutation.mutate();
        }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: submitTransferRequestMutation.isError, message: "Failed to submit transfer request! Please try again." }), _jsx(ErrorSnackbar, { open: deleteTransferRequestMutation.isError, message: "Failed to cancel transfer request! Please try again." }), _jsx(ErrorSnackbar, { open: !!userTransferRequestsError, message: "Failed to load transfer requests!" }), isRefetching || userTransferRequestsIsLoading ? (_jsx(Button, { disabled: true, variant: "contained", color: "primary", children: "Fetching Transfer Status..." })) : deleteTransferRequestMutation.isLoading ? (_jsx(Button, { disabled: true, variant: "contained", color: "primary", children: "Cancelling..." })) : submitTransferRequestMutation.isLoading ? (_jsx(Button, { disabled: true, variant: "contained", color: "primary", children: "Submitting..." })) : teamTransferRequest ? (_jsx(Button, { onClick: handleCancel, variant: "contained", color: "primary", children: "Cancel Transfer Request" })) : (_jsx(Button, { onClick: handleSubmit, variant: "contained", color: "primary", children: "Submit Transfer Request" }))] }));
};
